<div id="tickerAgentDetails" class="content-div">
  <!-- Help sections (hidden by default) -->
  <div id="helpAgentDetail" data-title="{{ 'ticker:help_title_agent' | i18next }}" style="display: none;">
    {{ 'ticker:help_agent' | i18next }}
  </div>
  <div id="helpAgentStatus" data-title="{{ 'ticker:help_title_agentPauses' | i18next }}" style="display: none;">
    {{ 'ticker:help_agentPauses' | i18next }}
  </div>

  <!-- Error pane -->
  <div class="error-pane" id="errorPane" *ngIf="errorMessage">
    <div class="error-message">{{ errorMessage }}</div>
  </div>

    <div class="info-bar">
      <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
      <app-basic-button id="help-btn-ticker-agent" type="secondary" isIcon="true" size="medium" (click)="openAgentHelp()">
        <i class="fal far fa-info-circle fs-16"></i>
      </app-basic-button>
    </div>
    <div class="top-bar">
    <span class="page-header">@if(!isLoading) { {{ 'ticker:ticker_detailsHeader' | i18next }} }<span class="header-details">{{ currentAgentData?.userName }}</span> </span>
    <div class="right" style="align-items: flex-end;">
      <app-basic-dropdown
        id="agent-dropdown-ticker-agent"
        [items]="otherAgents"
        bindLabel="name"
        bindValue="id"
        [(model)]="userId"
        (modelChange)="onAgentChange($event)"
        [label]="'realtime:agent' | i18next "
        placeholder="{{ 'realtime:select_agent' | i18next : { defaultValue: 'Select Agent' } }}">
      </app-basic-dropdown>
      <div class="toggleButtons" style="margin-left: 16px;">
        <app-basic-button id="day-window-btn-ticker-agent" [type]="selectedWindow === 'day' ? 'primary' : 'secondary'" [text]="'ticker:day' | i18next" fontSize="12px"
        size="small" (click)="onSelectWindow('day')" [dropShadow]="false"></app-basic-button>
        <app-basic-button id="week-window-btn-ticker-agent" [type]="selectedWindow === 'week' ? 'primary' : 'secondary'" [text]="'ticker:week' | i18next" fontSize="12px"
        size="small" (click)="onSelectWindow('week')" [dropShadow]="false"></app-basic-button>
      </div>
    </div>
  </div>

  <!-- Agent Summary Section -->
  <div id="tickerAgentSummary" class="agent-summary">
    <div id="agentStatusDetails" class="status-details">
      <div class="summarySection" id="totalTimeLoggedOnBox">
        <span class="summarySectionHeader">{{ 'ticker:agent_totalLoggedOn' | i18next : { defaultValue: 'Total Logged On' } }}</span>
        <span class="summarySectionContent" id="timeLoggedOn">{{ agentSummary?.loggedIn || '—' }}</span>
      </div>

      <div class="summarySection" id="timeInPauseBox">
        <span class="summarySectionHeader">{{ 'ticker:agent_totalInPause' | i18next : { defaultValue: 'Total In Pause' } }}</span>
        <span class="summarySectionContent" id="timeInPause">{{ agentSummary?.inPause || '—' }}</span>
      </div>

      <div class="summarySection" id="pauseDetailsBox">
        <span class="summarySectionHeader">{{ 'ticker:agent_pauseDetails' | i18next : { defaultValue: 'Pause Details' } }}</span>
        <span class="summarySectionContent" id="pauseDetails">
          @for (pause of agentSummary?.pauses; track pause.id; let last = $last) {
            {{ pause.description }} - {{ pause.timePaused }}@if (!last) {, }
          }
        <span *ngIf="!(agentSummary?.pauses?.length > 0)">{{'ticker:agent_err_noPauseDetails' | i18next }}</span>
        </span>
      </div>
      <app-basic-button id="help-agent-status-btn-ticker-agent" type="secondary" isIcon="true" size="medium" (click)="openAgentStatusHelp()">
        <i class="fal far fa-info-circle fs-16"></i>
      </app-basic-button>
    </div>

    <div id="clearer"></div>
  </div>

  <!-- Queues Table Section -->
  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <!-- No-data template -->
    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 full-width-table" id="tickerAgentQueuesTable">

      <!-- Queue Name Column -->
      <ng-container matColumnDef="queue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >
          {{ 'ticker:agent_queue' | i18next : { defaultValue: 'Queue' } }}
        </th>
        <td mat-cell *matCellDef="let row" >{{ row.queue }}</td>
        <td mat-footer-cell *matFooterCellDef >
          {{'ticker:queues_total' | i18next }}
        </td>
      </ng-container>

      <!-- Total Offered Column -->
      <ng-container matColumnDef="totalOffered">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >
          {{ 'ticker:agent_totalOffered' | i18next : { defaultValue: 'Total Offered' } }}
        </th>
        <td mat-cell *matCellDef="let row" class="text-right">{{ row.totalOffered }}</td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ totals?.totalOffered || '0' }}
        </td>
      </ng-container>

      <!-- Total Answered Column -->
      <ng-container matColumnDef="totalAnswered">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >
          {{ 'ticker:agent_totalAnswered' | i18next : { defaultValue: 'Total Answered' } }}
        </th>
        <td mat-cell *matCellDef="let row" class="text-right">{{ row.totalAnswered }}</td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ totals?.totalAnswered || '0' }}
        </td>
      </ng-container>

      <!-- Avg Survey Score Column (conditional) -->
      <ng-container *ngIf="showSurveyScore" matColumnDef="avgSurveyScore">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >
          {{ 'ticker:service_avgSurveyScore' | i18next : { defaultValue: 'Avg. Survey Score' } }}
        </th>
        <td mat-cell *matCellDef="let row" class="text-right">{{!row.formattedAvgSurveyScore || row.formattedAvgSurveyScore=="NaN"?('ticker:NaN' | i18next):row.formattedAvgSurveyScore }}</td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          @if (!totals?.formattedAvgSurveyScore || totals?.formattedAvgSurveyScore=="NaN") { &#x2012; }
          @else { {{'('}} {{ 'ticker:usergroups_lang_average' | i18next }} {{ totals?.formattedAvgSurveyScore }} {{')'}} }
        </td>
      </ng-container>

      <!-- Answer Rate Column -->
      <ng-container matColumnDef="answerRate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >
          {{ 'ticker:agent_answerRate' | i18next : { defaultValue: 'Answer Rate' } }}
        </th>
        <td mat-cell *matCellDef="let row" class="text-right">{{ row.formattedAnswerRate=="NaN"?('ticker:NaN' | i18next):row.formattedAnswerRate }}</td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ totals?.formattedAnswerRate=="NaN"?('ticker:NaN' | i18next):totals?.formattedAnswerRate }}
        </td>
      </ng-container>

      <!-- Avg Speak Time Column -->
      <ng-container matColumnDef="avgSpeak">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >
          {{ 'ticker:service_avgSpeakTime' | i18next : { defaultValue: 'Avg. Speak Time' } }}
        </th>
        <td mat-cell *matCellDef="let row" class="text-right">{{ row.formattedSecondsAvgSpeak=="NaN"?('ticker:NaN' | i18next):row.formattedSecondsAvgSpeak }}</td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          ({{ 'ticker:usergroups_lang_average' | i18next }} {{ totals?.formattedSecondsAvgSpeak || '0:00' }})
        </td>
      </ng-container>

      <!-- Avg Wrapup Time Column -->
      <ng-container matColumnDef="avgWrapup">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >
          {{ 'ticker:service_avgWrapupTime' | i18next : { defaultValue: 'Avg. Wrap-up Time' } }}
        </th>
        <td mat-cell *matCellDef="let row" class="text-right">{{ row.formattedSecondsAvgWrapup=="NaN"?('ticker:NaN' | i18next):row.formattedSecondsAvgWrapup }}</td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          ({{ 'ticker:usergroups_lang_average' | i18next }} {{ totals?.formattedSecondsAvgWrapup || '0:00' }})
        </td>
      </ng-container>

      <!-- AHT Column -->
      <ng-container matColumnDef="aht">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_AHT' | i18next : { defaultValue: 'AHT' } }}
        </th>
        <td mat-cell *matCellDef="let row" class="text-right">{{ row.formattedSecondsAHT=="NaN"?('ticker:NaN' | i18next):row.formattedSecondsAHT }}</td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          ({{ 'ticker:usergroups_lang_average' | i18next }} {{ totals?.formattedSecondsAHT || '0:00' }})
        </td>
      </ng-container>

      <!-- Header and Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- No data row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>

      <tr mat-footer-row *matFooterRowDef="displayedFooterColumns" class="footer-row" [hidden]="dataSource.filteredData.length == 0"></tr>

      <!-- Loading row -->
      <tr *ngIf="isLoading" mat-row>
        <td [attr.colspan]="displayedColumns.length" class="loading-cell">
          <span class="loading blockCenter">Loading...</span>
        </td>
      </tr>
    </table>
  </div>
</div>
